/** Tipos y conversiones de dominio: en @habitos/assistant (compartidos con el servidor). */
import type { LocalRecord } from '../db/db';
import type { WithId } from '@habitos/assistant/domain/model';

export * from '@habitos/assistant/domain/model';

export function decode<T>(r: LocalRecord): WithId<T> {
  return { ...(r.data as T), id: r.id };
}
